/** The exact Approve confirmation copy for a sector shift (wargame 21 spec §3.8). */
export const approveCopy = (shed: string, targets: string): string =>
  `Approving sheds ${shed} and promotes ${targets}. ` +
  'A target that fails revalidation is permanently FAILED (not substituted).'
